import type { ChatStep } from '../../../types/stream.types';
import type { ToolRenderer } from './tool-renderer.types';
import { DefaultToolRenderer } from './tool-renderers/default-tool-renderer';
import { SearchToolRenderer } from './tool-renderers/search-tool-renderer';
import { DocumentToolRenderer } from './tool-renderers/document-tool-renderer';

const toolRenderers: Record<string, ToolRenderer> = {
  search_knowledge_base: new SearchToolRenderer(),
  search_documents: new DocumentToolRenderer(),
  get_document: new DocumentToolRenderer(),
  list_documents: new DocumentToolRenderer(),
  get_document_content: new DocumentToolRenderer(),
  default: new DefaultToolRenderer(),
};

export function getToolRenderer(step: ChatStep): ToolRenderer {
  const toolName = step.metadata?.tool_name as string | undefined;
  if (toolName && toolRenderers[toolName]) {
    return toolRenderers[toolName];
  }
  return toolRenderers.default;
}

export function registerToolRenderer(toolName: string, renderer: ToolRenderer): void {
  toolRenderers[toolName] = renderer;
}
